import { useCallback, useEffect, useState } from "react";

export const useTerminal = () => {
  const [terminalRef, setDomNode] = useState();
  const setTerminalRef = useCallback(
    (node) => setDomNode(node),
    []
  );
  const [history, setHistory] = useState([]);
  const [openTerminal, setOpenTerminal] = useState(false);
  const [username, setUsername] = useState("User");
  const [openLogin, setOpenLogin] = useState(0);

  useEffect(() => {
    const windowResizeEvent = () => {
      terminalRef?.scrollTo({
        top: terminalRef?.scrollHeight ?? 99999,
        behavior: "smooth",
      });
    };
    window.addEventListener("resize", windowResizeEvent);

    return () => {
      window.removeEventListener("resize", windowResizeEvent);
    };
  }, [terminalRef]);

  useEffect(() => {
    terminalRef?.scrollTo({
      top: terminalRef?.scrollHeight ?? 99999,
      behavior: "smooth",
    });
  }, [history, terminalRef]);

  const pushToHistory = useCallback((item) => {
    setHistory((old) => [...old, item]);
  }, []);

  const pushToHistoryWithDelay = useCallback(
    ({ delay = 0, content }) =>
      new Promise((resolve) => {
        setTimeout(() => {
          pushToHistory(content);
          return resolve(content);
        }, delay);
      }),
    [pushToHistory]
  );

  const resetTerminal = useCallback(() => {
    setHistory([]);
  }, []);

  return {
    history,
    pushToHistory,
    pushToHistoryWithDelay,
    terminalRef,
    setTerminalRef,
    resetTerminal,
    setHistory,
    openTerminal,
    setOpenTerminal,
    openLogin,
    setOpenLogin,
    username,
    setUsername,
  };
};
